import React from 'react';
import { Button, Modal } from 'antd';

export default function ModalInfo({ info }) {

    return info && (
        <Modal
            title={info.topTitle}
            visible={true} footer={null}
            closable={false} maskClosable={false}
            wrapClassName='modal-custom-info'
        >
            <div className='modal-custom-info-content'>
                <em className={`fal ${info.icon}`} />
                <h1>{info.title}</h1>
                <h2></h2>
                <p>{info.description}</p>
                <div className='modal-custom-info-content-footer'>
                    {info.action === 'reload' && (<Button className='ant-btn-outline c-2 ant-btn-size-xs'
                        onClick={() => window.location.reload()}>
                        INICIO
                    </Button>)}
                </div>
            </div>
        </Modal>
    )
}